import { render, staticRenderFns } from "./CDLastActiveProjectCard.vue?vue&type=template&id=162079fe&scoped=true"
import script from "./CDLastActiveProjectCard.vue?vue&type=script&lang=ts"
export * from "./CDLastActiveProjectCard.vue?vue&type=script&lang=ts"
import style0 from "./CDLastActiveProjectCard.vue?vue&type=style&index=0&id=162079fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162079fe",
  null
  
)

export default component.exports